import {
  DEFAULT_PLAYER_GAME_ORDERING,
  baseFetchPlayerGameStats,
  baseFetchPlayerSpanStats,
  baseFetchPlayerStreakStats,
  baseFetchTeamGameStats,
} from './api';
import API_URLS from './api_urls';

export const fetchNcaaMbbPlayerGameStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchPlayerGameStats(
  API_URLS.ncaambb.player_game_finder, filters, signOut, page, sortBy, uuid
);

export const fetchNcaaMbbPlayerStreakStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchPlayerStreakStats(
  API_URLS.ncaambb.player_streak_finder, filters, signOut, page, sortBy, uuid
);

export const fetchNcaaPlayerSpanStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchPlayerSpanStats(
  API_URLS.ncaambb.player_span_finder, filters, signOut, page, sortBy, uuid
);

export const fetchNcaaMbbTeamGameStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchTeamGameStats(
  API_URLS.ncaambb.team_game_finder, filters, signOut, page, sortBy, uuid
);

export const fetchNcaaMbbTeamStreakStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchTeamGameStats(
  API_URLS.ncaambb.team_streak_finder, filters, signOut, page, sortBy, uuid
);

export const fetchNcaaMbbTeamSpanStats = async (
  filters: Array<string>,
  signOut: () => boolean,
  page = 0,
  sortBy = DEFAULT_PLAYER_GAME_ORDERING,
  uuid?: string,
) => baseFetchTeamGameStats(
  API_URLS.ncaambb.team_span_finder, filters, signOut, page, sortBy, uuid
);
